module.exports = __webpack_public_path__ + "img/text.f4de5e17.png";